import { IconElement } from '@wix/design-system';
import React from 'react';
import ErrorConePage from '../ErrorConePage/ErrorConePage';

type ProfileBuilderDownErrorProps = {
  titleKey: string;
  descriptionKey: string;
  actionKey?: string;
  onAction?: () => void;
  actionPrefixIcon?: IconElement;
  withTryAgain?: boolean;
  tryAgainKey?: string;
  onTryAgain?: () => void;
};

export const DsBuilderDownError: React.FC<ProfileBuilderDownErrorProps> = ({
  onAction,
  titleKey,
  descriptionKey,
  actionKey,
  actionPrefixIcon,
  withTryAgain,
  tryAgainKey,
  onTryAgain,
}) => {
  return (
    <ErrorConePage
      titleKey={titleKey}
      subtitleKey={descriptionKey}
      additionalActionKey={actionKey}
      additionalAction={onAction ?? undefined}
      additionalActionPrefixIcon={actionPrefixIcon}
      tryAgainKey={tryAgainKey}
      withTryAgain={withTryAgain}
      onTryAgain={onTryAgain}
    />
  );
};
